"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _axios = _interopRequireDefault(require("axios"));

var _DashboardTimezoneDisclaimer = require("./DashboardTimezoneDisclaimer");

var _KeyInsightCard = require("./KeyInsightCard");

var _AnalyticsDateFormatter = _interopRequireDefault(require("./AnalyticsDateFormatter"));

var _interfaces = require("./interfaces");

var _utils = require("./utils");

var _DashboardSimpleFilter = _interopRequireDefault(require("./DashboardSimpleFilter"));

var _DashboardCategoryFilter = _interopRequireDefault(require("./DashboardCategoryFilter"));

var _UniqueViewsOfHelpfulContentOverTime = _interopRequireDefault(require("./SelfServiceDashboard/UniqueViewsOfHelpfulContentOverTime"));

var _SelfServiceScoreOverTime = _interopRequireDefault(require("./SelfServiceDashboard/SelfServiceScoreOverTime"));

var _QueryParameters = _interopRequireDefault(require("./QueryParameters"));

var _Message = require("../ui-components/Message");

var _logger = require("@insided/shared/services/logger");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SelfServiceDashboard = /*#__PURE__*/function (_Dashboard) {
  (0, _inherits2.default)(SelfServiceDashboard, _Dashboard);

  var _super = _createSuper(SelfServiceDashboard);

  function SelfServiceDashboard() {
    var _thisSuper, _this;

    (0, _classCallCheck2.default)(this, SelfServiceDashboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", _this.getInitialState());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0, _utils.trackDashboardUsage)('self-service-dashboard');
              _context.next = 3;
              return Promise.all([(0, _get2.default)((_thisSuper = (0, _assertThisInitialized2.default)(_this), (0, _getPrototypeOf2.default)(SelfServiceDashboard.prototype)), "componentDidMount", _thisSuper).call(_thisSuper), _this.fetchUserRoles(), _this.fetchUniqueViewsOfHelpfulContent(), _this.fetchUniqueUsersRaisingTickets()]);

            case 3:
              _this.calculateSelfServiceScore();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchUserRoles", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var res, userRoles, mainRoles, customRoles;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _axios.default.get('/role/fetchRolesForFilter');

            case 2:
              res = _context2.sent;
              userRoles = (0, _utils.normalizeRoles)(res.data);
              mainRoles = (0, _utils.getSelectedRolesForRequest)(userRoles, _this.state.selectedRoles);
              customRoles = (0, _utils.getSelectedRolesForRequest)(userRoles, _this.state.selectedRoles, false);

              _this.setState({
                userRoles: userRoles,
                mainRoles: mainRoles,
                customRoles: customRoles
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refetchData", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this.setState({
                isSelfServiceScoreKeyInsightLoading: true
              });

              _context3.next = 3;
              return Promise.all([_this.fetchUniqueViewsOfHelpfulContent(), _this.fetchUniqueUsersRaisingTickets()]);

            case 3:
              _this.calculateSelfServiceScore();

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchUniqueViewsOfHelpfulContent", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var res, uniqueViewsOfHelpfulContent;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this.setState({
                isUniqueViewsOfHelpfulContentKeyInsightLoading: true
              });

              _context4.prev = 1;
              _context4.next = 4;
              return _this.fetchData('/analyticsV2/uniqueViewsOfHelpfulContent');

            case 4:
              res = _context4.sent;
              uniqueViewsOfHelpfulContent = res.data;
              uniqueViewsOfHelpfulContent.percentageDifference = (0, _utils.previousPeriodDifference)(uniqueViewsOfHelpfulContent.count, uniqueViewsOfHelpfulContent.previousCount);

              _this.setState({
                uniqueViewsOfHelpfulContent: uniqueViewsOfHelpfulContent,
                isUniqueViewsOfHelpfulContentKeyInsightLoading: false
              });

              _context4.next = 14;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](1);

              _logger.logger.error(_context4.t0, {
                component: 'SelfServiceDashboard',
                action: 'fetchUniqueViewsOfHelpfulContent'
              });

              _this.setState({
                isUniqueViewsOfHelpfulContentKeyInsightLoading: false
              });

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchUniqueUsersRaisingTickets", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      var res, uniqueUsersRaisingTickets;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this.setState({
                isUniqueUsersRaisingTicketsKeyInsightLoading: true
              });

              _context5.prev = 1;
              _context5.next = 4;
              return _this.fetchData('/analyticsV2/uniqueUsersRaisingTickets');

            case 4:
              res = _context5.sent;
              uniqueUsersRaisingTickets = res.data;
              uniqueUsersRaisingTickets.percentageDifference = (0, _utils.previousPeriodDifference)(uniqueUsersRaisingTickets.count, uniqueUsersRaisingTickets.previousCount);

              _this.setState({
                uniqueUsersRaisingTickets: uniqueUsersRaisingTickets,
                isUniqueUsersRaisingTicketsKeyInsightLoading: false
              });

              _context5.next = 14;
              break;

            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](1);

              _logger.logger.error(_context5.t0, {
                component: 'SelfServiceDashboard',
                action: 'fetchUniqueUsersRaisingTickets'
              });

              _this.setState({
                isUniqueUsersRaisingTicketsKeyInsightLoading: false
              });

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 10]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "calculateSelfServiceScore", function () {
      _this.setState({
        isSelfServiceScoreKeyInsightLoading: true
      });

      var _this$state = _this.state,
          uniqueUsersRaisingTickets = _this$state.uniqueUsersRaisingTickets,
          uniqueViewsOfHelpfulContent = _this$state.uniqueViewsOfHelpfulContent;

      if (uniqueUsersRaisingTickets !== undefined && uniqueViewsOfHelpfulContent !== undefined && uniqueUsersRaisingTickets.count !== 0) {
        var selfServiceScore = uniqueViewsOfHelpfulContent.count / uniqueUsersRaisingTickets.count;
        var roundedOffSelfServiceScore = Number(selfServiceScore.toFixed(2));

        _this.setState({
          selfServiceScore: roundedOffSelfServiceScore,
          isSelfServiceScoreKeyInsightLoading: false
        });
      }

      _this.setState({
        isSelfServiceScoreKeyInsightLoading: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchData", /*#__PURE__*/function () {
      var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(url) {
        var _this$state2, startDate, endDate, mainRoles, customRoles, selectedCategories, selectedContentTypes, filterOptions;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this$state2 = _this.state, startDate = _this$state2.startDate, endDate = _this$state2.endDate, mainRoles = _this$state2.mainRoles, customRoles = _this$state2.customRoles, selectedCategories = _this$state2.selectedCategories, selectedContentTypes = _this$state2.selectedContentTypes;
                filterOptions = {
                  start: _AnalyticsDateFormatter.default.formatDate(startDate),
                  end: _AnalyticsDateFormatter.default.formatDate(endDate, false),
                  mainRoles: mainRoles,
                  customRoles: customRoles,
                  categories: selectedCategories,
                  contentTypes: selectedContentTypes
                };
                _context6.next = 4;
                return _axios.default.post(url, {
                  filters: filterOptions
                });

              case 4:
                return _context6.abrupt("return", _context6.sent);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleUserRoleDropdown", function (value) {
      if (_this.state.isDateRangeOpen) {
        _this.onResetDateRange();
      }

      if (_this.state.isCategoryDropdownOpen) {
        _this.onResetCategories();
      }

      if (_this.state.isContentTypeDropdownOpen) {
        _this.onResetContentTypes();
      }

      _this.setState({
        isUserRoleDropdownOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUserRolesChanged", function (data) {
      var userRoles = _this.state.userRoles;
      var mainRoles = (0, _utils.getSelectedRolesForRequest)(userRoles, data);
      var customRoles = (0, _utils.getSelectedRolesForRequest)(userRoles, data, false);

      _this.setState({
        isUserRoleDropdownOpen: false,
        selectedRoles: data,
        mainRoles: mainRoles,
        customRoles: customRoles
      });

      window.history.pushState(null, 'roles changed', new _QueryParameters.default().set('roles', data.join(',')).getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetUserRoles", function () {
      _this.setState({
        isUserRoleDropdownOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearUserRoles", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        selectedRoles: [],
        mainRoles: [],
        customRoles: [],
        isUserRoleDropdownOpen: false
      });

      window.history.pushState(null, 'roles cleared', new _QueryParameters.default().unset('roles').getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleContentTypeDropdown", function (value) {
      if (_this.state.isDateRangeOpen) {
        _this.onResetDateRange();
      }

      if (_this.state.isUserRoleDropdownOpen) {
        _this.onResetUserRoles();
      }

      if (_this.state.isCategoryDropdownOpen) {
        _this.onResetCategories();
      }

      _this.setState({
        isContentTypeDropdownOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onContentTypesChanged", function (data) {
      _this.setState({
        isContentTypeDropdownOpen: false,
        selectedContentTypes: data
      });

      window.history.pushState(null, 'content types changed', new _QueryParameters.default().set('content_types', data.join(',')).getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetContentTypes", function () {
      _this.setState({
        isContentTypeDropdownOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearContentTypes", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        selectedContentTypes: [],
        isContentTypeDropdownOpen: false
      });

      window.history.pushState(null, 'content_types cleared', new _QueryParameters.default().unset('content_types').getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleCategoryDropdown", function (value) {
      if (_this.state.isDateRangeOpen) {
        _this.onResetDateRange();
      }

      if (_this.state.isUserRoleDropdownOpen) {
        _this.onResetUserRoles();
      }

      if (_this.state.isContentTypeDropdownOpen) {
        _this.onResetContentTypes();
      }

      _this.setState({
        isCategoryDropdownOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCategoriesChanged", function (data) {
      _this.setState({
        selectedCategories: data,
        isCategoryDropdownOpen: false
      });

      window.history.pushState(null, 'categories changed', new _QueryParameters.default().set('categories', data.join(',')).getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetCategories", function () {
      _this.setState({
        isCategoryDropdownOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearCategories", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        selectedCategories: [],
        isCategoryDropdownOpen: false
      });

      window.history.pushState(null, 'categories cleared', new _QueryParameters.default().unset('categories').getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleDateRange", function (value) {
      if (_this.state.isCategoryDropdownOpen) {
        _this.onResetCategories();
      }

      if (_this.state.isUserRoleDropdownOpen) {
        _this.onResetUserRoles();
      }

      if (_this.state.isContentTypeDropdownOpen) {
        _this.onResetContentTypes();
      }

      _this.setState({
        isDateRangeOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addHandler", function () {
      var _this$state3 = _this.state,
          isDateRangeOpen = _this$state3.isDateRangeOpen,
          isUserRoleDropdownOpen = _this$state3.isUserRoleDropdownOpen,
          isContentTypeDropdownOpen = _this$state3.isContentTypeDropdownOpen,
          isCategoryDropdownOpen = _this$state3.isCategoryDropdownOpen;

      if (isDateRangeOpen || isUserRoleDropdownOpen || isContentTypeDropdownOpen || isCategoryDropdownOpen) {
        window.document.addEventListener('mousedown', _this.handleClickOutside);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeHandler", function () {
      window.document.removeEventListener('mousedown', _this.handleClickOutside);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (e) {
      if (!_this.wrapperRef) return;

      if (!_this.wrapperRef.contains(e.target)) {
        _this.onResetDateRange();

        _this.setState({
          isUserRoleDropdownOpen: false,
          isContentTypeDropdownOpen: false,
          isCategoryDropdownOpen: false
        }, _this.removeHandler);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(SelfServiceDashboard, [{
    key: "getInitialState",
    value: function getInitialState() {
      var queryParams = new _QueryParameters.default();

      var state = _objectSpread(_objectSpread({}, (0, _get2.default)((0, _getPrototypeOf2.default)(SelfServiceDashboard.prototype), "getInitialState", this).call(this)), {}, {
        uniqueViewsOfHelpfulContent: (0, _utils.createDefaultMetricItem)(),
        uniqueUsersRaisingTickets: (0, _utils.createDefaultMetricItem)(),
        userRoles: [],
        mainRoles: [],
        customRoles: [],
        selectedRoles: queryParams.has('roles') ? queryParams.get('roles').split(',') : [],
        isUserRoleDropdownOpen: false,
        isUniqueViewsOfHelpfulContentKeyInsightLoading: false,
        isUniqueUsersRaisingTicketsKeyInsightLoading: false,
        isSelfServiceScoreKeyInsightLoading: false,
        contentTypes: [{
          id: 0,
          name: 'Conversation',
          value: 'discussion'
        }, {
          id: 1,
          name: 'Answered question',
          value: 'question'
        }, {
          id: 2,
          name: 'Article',
          value: 'article'
        }],
        selectedContentTypes: queryParams.has('content_types') ? queryParams.get('content_types').split(',') : [],
        isContentTypeDropdownOpen: false,
        selectedCategories: queryParams.has('categories') ? queryParams.get('categories').split(',') : [],
        isCategoryDropdownOpen: false,
        selfServiceScore: 0
      });

      return state;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isSyncTicketDataActive = _this$props.isSyncTicketDataActive,
          categoriesV2 = _this$props.categoriesV2;
      var _this$state4 = this.state,
          isUniqueViewsOfHelpfulContentKeyInsightLoading = _this$state4.isUniqueViewsOfHelpfulContentKeyInsightLoading,
          isUniqueUsersRaisingTicketsKeyInsightLoading = _this$state4.isUniqueUsersRaisingTicketsKeyInsightLoading,
          isSelfServiceScoreKeyInsightLoading = _this$state4.isSelfServiceScoreKeyInsightLoading,
          selfServiceScore = _this$state4.selfServiceScore,
          uniqueViewsOfHelpfulContent = _this$state4.uniqueViewsOfHelpfulContent,
          uniqueUsersRaisingTickets = _this$state4.uniqueUsersRaisingTickets,
          userRoles = _this$state4.userRoles,
          selectedRoles = _this$state4.selectedRoles,
          isUserRoleDropdownOpen = _this$state4.isUserRoleDropdownOpen,
          startDate = _this$state4.startDate,
          endDate = _this$state4.endDate,
          isLoading = _this$state4.isLoading,
          selectedCategories = _this$state4.selectedCategories,
          isCategoryDropdownOpen = _this$state4.isCategoryDropdownOpen,
          contentTypes = _this$state4.contentTypes,
          selectedContentTypes = _this$state4.selectedContentTypes,
          isContentTypeDropdownOpen = _this$state4.isContentTypeDropdownOpen,
          shouldChartRedraw = _this$state4.shouldChartRedraw;
      return (0, _preact.h)("div", {
        className: "self-service-dashboard-overview dashboard-overview",
        "data-bounded-context": "Analytics",
        "data-entity": "self-service-dashboard"
      }, (0, _preact.h)(_header.default, {
        title: "Self-service Dashboard",
        disableCancelButton: true,
        disableSaveButton: true
      }), !isSyncTicketDataActive ? (0, _preact.h)(_Message.Message, {
        variant: "warning",
        text: (0, _preact.h)("div", null, "To calculate your self-service score, please", ' ', (0, _preact.h)("a", {
          target: "blank",
          "data-element-name": "Zendesk integration link",
          "data-track-type": "click",
          href: (0, _absoluteUrlRuntime.resolveUrl)("/settings/integrations/zendesk")
        }, "configure the Zendesk integration"), ' ', "and enable 'Measure your self-service score'.")
      }) : null, (0, _preact.h)("div", {
        className: "filter-container",
        ref: function ref(node) {
          _this2.wrapperRef = node;
        }
      }, this.getDateRangeFilter(), (0, _preact.h)(_DashboardCategoryFilter.default, {
        isLoading: isLoading,
        id: "categories",
        name: "(parent) category or group",
        customClassName: "categories",
        title: "Published in",
        isDropdownOpen: isCategoryDropdownOpen,
        toggleDropdown: function toggleDropdown(v) {
          return _this2.toggleCategoryDropdown(v);
        },
        resetDropdown: function resetDropdown() {
          return _this2.onResetCategories();
        },
        onClear: function onClear(e) {
          return _this2.onClearCategories(e);
        },
        onChange: function onChange(data) {
          return _this2.onCategoriesChanged(data);
        },
        categoriesV2: categoriesV2,
        selectedItems: selectedCategories
      }), (0, _preact.h)(_DashboardSimpleFilter.default, {
        isLoading: isLoading,
        id: "contentType",
        name: "content type",
        customClassName: "content-type",
        title: "Content type",
        isDropdownOpen: isContentTypeDropdownOpen,
        toggleDropdown: function toggleDropdown(v) {
          return _this2.toggleContentTypeDropdown(v);
        },
        resetDropdown: function resetDropdown() {
          return _this2.onResetContentTypes();
        },
        onClear: function onClear(e) {
          return _this2.onClearContentTypes(e);
        },
        onChange: function onChange(data) {
          return _this2.onContentTypesChanged(data);
        },
        items: contentTypes,
        selectedItems: selectedContentTypes,
        "data-element-name": "Content type filter",
        "data-track-type": "click"
      }), (0, _preact.h)(_DashboardSimpleFilter.default, {
        isLoading: isLoading,
        id: "userRole",
        name: "user role",
        customClassName: "user-role",
        title: "User role",
        isDropdownOpen: isUserRoleDropdownOpen,
        toggleDropdown: function toggleDropdown(v) {
          return _this2.toggleUserRoleDropdown(v);
        },
        resetDropdown: function resetDropdown() {
          return _this2.onResetUserRoles();
        },
        onClear: function onClear(e) {
          return _this2.onClearUserRoles(e);
        },
        onChange: function onChange(data) {
          return _this2.onUserRolesChanged(data);
        },
        items: userRoles,
        selectedItems: selectedRoles,
        "data-element-name": "User role filter",
        "data-track-type": "click"
      })), (0, _preact.h)("div", {
        className: "metric-container"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Self-service score",
        total: selfServiceScore,
        titleTooltip: "The ratio of unique visitors who viewed help content to unique users who created a ticket in the selected time period.",
        isLoading: isSelfServiceScoreKeyInsightLoading,
        hideComparisionWithPreviousPeriod: true,
        isKeyInsightAvailable: isSyncTicketDataActive,
        keyInsightUnavailableMessage: " No tracked data "
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Unique visitors who viewed help content",
        total: uniqueViewsOfHelpfulContent.count,
        titleTooltip: "The number of unique visitors who viewed an article, question with a best answer, or a conversation on the community in the selected time period.",
        percent: uniqueViewsOfHelpfulContent.percentageDifference,
        isLoading: isUniqueViewsOfHelpfulContentKeyInsightLoading,
        showComparisionUnavailable: uniqueViewsOfHelpfulContent.previousCount === 0,
        comparisionTooltip: "The percentage difference between the number of unique visitors who viewed help content in the current/previous time period."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Unique users who created tickets",
        total: uniqueUsersRaisingTickets.count,
        titleTooltip: "The number of unique users who created a support ticket in the selected time period.",
        percent: uniqueUsersRaisingTickets.percentageDifference,
        isLoading: isUniqueUsersRaisingTicketsKeyInsightLoading,
        showComparisionUnavailable: uniqueUsersRaisingTickets.previousCount === 0,
        comparisionTooltip: "The percentage difference between the number of unique visitors who created tickets in the current/previous time period.",
        isKeyInsightAvailable: isSyncTicketDataActive,
        keyInsightUnavailableMessage: " No tracked data "
      })), (0, _preact.h)("div", {
        className: "graph-wrapper"
      }, (0, _preact.h)("div", {
        className: "graph-container",
        ref: function ref(element) {
          _this2.barChart = element;
        }
      }, (0, _preact.h)(_SelfServiceScoreOverTime.default, {
        startDate: startDate,
        endDate: endDate,
        selectedRoles: selectedRoles,
        selectedCategories: selectedCategories,
        selectedContentTypes: selectedContentTypes,
        shouldChartRedraw: shouldChartRedraw,
        isSyncTicketDataActive: isSyncTicketDataActive,
        fetchData: /*#__PURE__*/function () {
          var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(url) {
            return _regenerator.default.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _context7.next = 2;
                    return _this2.fetchData(url);

                  case 2:
                    return _context7.abrupt("return", _context7.sent);

                  case 3:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7);
          }));

          return function (_x2) {
            return _ref7.apply(this, arguments);
          };
        }()
      }), (0, _preact.h)(_UniqueViewsOfHelpfulContentOverTime.default, {
        startDate: startDate,
        endDate: endDate,
        selectedRoles: selectedRoles,
        selectedCategories: selectedCategories,
        selectedContentTypes: selectedContentTypes,
        shouldChartRedraw: shouldChartRedraw,
        fetchData: /*#__PURE__*/function () {
          var _ref8 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(url) {
            return _regenerator.default.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _context8.next = 2;
                    return _this2.fetchData(url);

                  case 2:
                    return _context8.abrupt("return", _context8.sent);

                  case 3:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8);
          }));

          return function (_x3) {
            return _ref8.apply(this, arguments);
          };
        }()
      }))), (0, _preact.h)(_DashboardTimezoneDisclaimer.DashboardTimezoneDisclaimer, null));
    }
  }]);
  return SelfServiceDashboard;
}(_interfaces.Dashboard);

var _default = SelfServiceDashboard;
exports.default = _default;